export class SpinButtonEvents {
	public static readonly PRE_SPIN_BUTTON_PRESSED: string = 'SpinButtonEvents::PRE_SPIN_BUTTON_PRESSED';
	public static readonly SPIN_BUTTON_PRESSED: string = 'SpinButtonEvents::__SPIN_BUTTON_PRESSED__';
	public static readonly QUICKSTOP_PRESSED: string = 'SpinButtonEvents::__QUICKSTOP_PRESSED__';
	public static readonly SPIN_BUTTON_HOLD: string = 'SpinButtonEvents::__SPIN_BUTTON_HOLD__';
	public static readonly START_AUTOPLAY_BUTTON_PRESSED: string = 'SpinButtonEvents::START_AUTOPLAY_BUTTON_PRESSED';
	public static readonly STOP_AUTOPLAY_BUTTON_PRESSED: string = 'SpinButtonEvents::__STOP_AUTOPLAY_BUTTON_PRESSED__';
	public static readonly SPIN_PRESSED_NOT_ENOUGH_MONEY: string = 'SpinButtonEvents::__SPIN_PRESSED_NOT_ENOUGH_MONEY__';
	public static readonly SPACE_BUTTON_CLICKED: string = 'SpinButtonEvents::__SPACE_BUTTON_CLICKED__';
	public static readonly SPIN_BUTTON_BECOMING_VISIBLE_AND_ENABLED: string = 'SpinButtonEvents::SPIN_BUTTON_BECOMING_VISIBLE_AND_ENABLED';

	public static readonly REGULATION_SPIN_DELAY_PASSED: string = 'SpinButtonEvents::REGULATION_SPIN_DELAY_PASSED';
	public static readonly REGULATION_SPIN_DELAY_STARTED: string = 'SpinButtonEvents::REGULATION_SPIN_DELAY_STARTED';

	public static readonly DISABLE_SPIN_BY_SPIN: string = 'SpinButtonEvents::DISABLE_SPIN_BY_SPIN';
	public static readonly ENABLE_SPIN_BY_SPIN: string = 'SpinButtonEvents::ENABLE_SPIN_BY_SPIN';
	public static readonly SKIP_BY_SPIN_BUTTON_PRESSED: string = 'SpinButtonEvents::SKIP_BY_SPIN_BUTTON_PRESSED';

	public static readonly SPIN_BUTTON_PHYSICALLY_CLICKED: string = 'SpinButtonEvents::SPIN_BUTTON_PHYSICALLY_CLICKED';
	public static readonly SPIN_BUTTON_SPACE_PHYSICALLY_CLICKED: string = 'SpinButtonEvents::SPIN_BUTTON_SPACE_PHYSICALLY_CLICKED';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonEvents.ts